/* eslint-disable no-console */
import { LogLevel, getConfigAsync } from './config';

export default async function log(LEVEL: LogLevel, ...message: unknown[]) {
  const logLevel = Number(await getConfigAsync('APP_LOG_LEVEL')) as number;
  if (LEVEL >= logLevel) {
    switch (LEVEL) {
      case LogLevel.DEBUG:
        console.debug(...message);
        break;
      case LogLevel.INFO:
        console.info(...message);
        break;
      case LogLevel.WARN:
        console.warn(...message);
        break;
      case LogLevel.ERROR:
        console.error(...message);
        break;
      default:
        break;
    }
  }
}

export async function logError(...message: unknown[]) {
  return log(LogLevel.ERROR, ...message);
}

export async function logInfo(...message: unknown[]) {
  return log(LogLevel.INFO, ...message);
}

export async function logDebug(...message: unknown[]) {
  return log(LogLevel.DEBUG, ...message);
}

export async function logWarn(...message: unknown[]) {
  return log(LogLevel.WARN, ...message);
}
